import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import { ImageMultiSkuOverlay } from 'dibs-image-multi-sku-overlay/exports/ImageMultiSkuOverlay';
import { CheckoutMobileSummaryPriceTable } from '../components/summary/CheckoutMobileSummaryPriceTable';

import { CheckoutReviewTally_transaction$key } from './__generated__/CheckoutReviewTally_transaction.graphql';
import { CheckoutReviewTally_item$key } from './__generated__/CheckoutReviewTally_item.graphql';

const itemFragment = graphql`
    fragment CheckoutReviewTally_item on Item {
        title
        ...ImageMultiSkuOverlay_item
        ...CheckoutMobileSummaryPriceTable_item
    }
`;

const transactionFragment = graphql`
    fragment CheckoutReviewTally_transaction on Transaction {
        sku {
            ...ImageMultiSkuOverlay_sku
        }
        ...CheckoutMobileSummaryPriceTable_transaction
    }
`;

type Props = {
    item: CheckoutReviewTally_item$key;
    transaction: CheckoutReviewTally_transaction$key;
    isComputing: boolean;
};

export const CheckoutReviewTally: FC<Props> = props => {
    const { transaction: transactionRef, item: itemRef, isComputing } = props;

    const transaction = useFragment(transactionFragment, transactionRef);
    const item = useFragment(itemFragment, itemRef);

    return (
        <div>
            <div className={cn(dibsCss.flex, dibsCss.flexRow)}>
                <div className={cn(dibsCss.wLarger, dibsCss.shrink0, dibsCss.mrSmall)}>
                    <ImageMultiSkuOverlay
                        item={item}
                        sku={transaction?.sku}
                        messageSize="small"
                        imageAlt={item?.title || ''}
                        useSuspense
                    />
                </div>
                <div className={dibsCss.sassyFontBodySmallHeavy}>{item?.title}</div>
            </div>
            <div className={dibsCss.mtSmall}>
                <CheckoutMobileSummaryPriceTable
                    item={item}
                    transaction={transaction}
                    isComputing={isComputing}
                />
            </div>
        </div>
    );
};
